module.exports = __webpack_public_path__ + "static/media/nvguagan.8eef135b.gif";